<div class="date-range-periods-container">
	<button mat-menu-item (click)="selectQuickDateRange(dateRangePeriods.periodToday)">
		{{ 'today' | translate }}
	</button>
	<button mat-menu-item (click)="selectQuickDateRange(dateRangePeriods.periodThisWeek)">
		{{ 'this_week' | translate }}
	</button>
	<button mat-menu-item (click)="selectQuickDateRange(dateRangePeriods.periodThisMonth)">
		{{ 'this_month' | translate }}
	</button>
	<button mat-menu-item (click)="selectQuickDateRange(dateRangePeriods.periodThisYear)">
		{{ 'this_year' | translate }}
	</button>
	<button mat-menu-item (click)="clearDateRange()" [matMenuTriggerFor]="customDateMenu">
		{{ 'custom' | translate }}
	</button>
</div>

<mat-menu #customDateMenu="matMenu" class="custom-date-picker-container">
	<div class="date-range-container" (click)="$event.stopPropagation()">
		<mat-calendar
			[selected]="selectedDateRange"
			(selectedChange)="selectedChange($event)"
			class="au-mat-calendar"
		></mat-calendar>
	</div>
</mat-menu>
